module.exports = __webpack_public_path__ + "static/banner-a7fe21b99cdbbd023250e37a22bd3528.jpg";